import React, { useEffect, useState } from 'react';
import { Routing } from './routing';
import { AuthProvider } from './hooks';
import { ensureI18nInitialized, isI18nInitialized } from './i18n';
import { Loader } from './components';
import { LanguageProvider } from '@/contexts/language-context-type';
import { BusinessSetupProvider } from '@/contexts/business-setup-context';
import { Toaster } from './components/ui/sonner';
import { useTenantTheme } from './hooks/use-tenant-theme';
import { applyTheme, resolveTheme } from './utils/theming';

export const App: React.FC = () => {
  const [i18nInitialized, setI18nInitialized] = useState(isI18nInitialized());

  const { theme, computedTheme } = useTenantTheme();

  useEffect(() => {
    if (computedTheme) {
      applyTheme(computedTheme);
      return;
    }

    if (!theme) return;
    applyTheme(resolveTheme(theme));
  }, [theme, computedTheme]);

  useEffect(() => {
    if (!i18nInitialized) {
      ensureI18nInitialized().then(() => {
        setI18nInitialized(true);
      });
    }
  }, [i18nInitialized]);

  if (!i18nInitialized) {
    return <Loader text="Loading..." />;
  }

  return (
    <LanguageProvider>
      <AuthProvider>
        <BusinessSetupProvider>
          <Routing />
          <Toaster richColors />
        </BusinessSetupProvider>
      </AuthProvider>
    </LanguageProvider>
  );
};
